import React from "react";
import { Controller } from "react-hook-form";
import Input from "./Input";
import { isValidMobile } from "@utils";

const MobilePhoneInput = ({
  name,
  control,
  displayName,
  required,
  errors,
  placeholder = null,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? `${displayName} is required` : null,
        validate: (value) =>
          !value ||
          isValidMobile(value) ||
          "Please enter a valid UK mobile phone number",
      }}
      render={({ field: { ref, ...field } }) => (
        <Input
          {...field}
          type="tel"
          placeholder={placeholder || "0712345678"}
          invalid={!!errors}
        />
      )}
    />
  );
};

export default MobilePhoneInput;
